<astral-select [control]="control" [itemsSource]="items" [helpText]="helpText"></astral-select>
